var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h2", { staticClass: "title is-4" }, [_vm._v("Historial de Recibos")]),
      _vm._v(" "),
      _c(
        "b-table",
        {
          class: _vm.recibos.length > 0 ? "cursor-pointer" : "cursor-default",
          attrs: {
            data: _vm.recibos,
            bordered: false,
            narrowed: false,
            hoverable: true,
            loading: _vm.isLoading,
            checkable: "",
            "checked-rows": _vm.selectedRecibos,
            "is-row-checkable": (row) =>
              row.estado !== "pendiente" ||
              _vm.$store.getters.hasAnyRole(["lyris", "empleador"]),
            "mobile-cards": true,
            sortable: true,
          },
          on: { dblclick: _vm.goToDocument, check: _vm.checkRow },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "is-family-monospace has-text-centered" },
                    [
                      _vm.isLoading
                        ? _c("span")
                        : _c("span", [
                            _vm._v(
                              "No hay recibos que cumplan con los filtros de busqueda"
                            ),
                          ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-table-column", {
            attrs: { field: "nombre", label: "Recibo", sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("span", { staticClass: "break-word" }, [
                      _c("i", { staticClass: "fas fa-dollar-sign" }),
                      _vm._v("  " + _vm._s(props.row.nombre)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm.$store.getters.hasAnyRole(["lyris", "empleador"])
            ? _c("b-table-column", {
                attrs: {
                  field: "empleado.usuario.apellido",
                  sortable: "",
                  label: "Empleado",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _vm._v(
                            "\n      " +
                              _vm._s(props.row.empleado.usuario.apellido) +
                              ", " +
                              _vm._s(props.row.empleado.usuario.nombre) +
                              "\n    "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1345604983
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: {
              field: "estado",
              label: "Conformidad",
              sortable: "",
              centered: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("span", [
                      _c("i", {
                        staticClass: "fas",
                        class: `${_vm.getConformidadIcon(
                          props.row.estado
                        )} ${_vm.getConformidadIcon(props.row.estado)}`,
                      }),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: {
              field: "fecha",
              label: "Fecha",
              sortable: "",
              centered: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("moment")(
                            new Date(props.row.fecha),
                            "DD/MM/YYYY"
                          )
                        ) +
                        "\n    "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: { label: "Tipo", centered: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(props.row.tipo_recibo.nombre) +
                        "\n    "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: { identifier: _vm.identifierLoaderDocuments },
          on: { infinite: _vm.infiniteHandlerDocuments },
        },
        [
          _c(
            "div",
            {
              staticClass: "py-5 is-size-7 is-family-monospace",
              attrs: { slot: "no-more" },
              slot: "no-more",
            },
            [
              _vm.isLoading
                ? _c("span", [_vm._v("Cargando...")])
                : _c("span", [_vm._v("~ Fin del listado ~")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "py-5 is-size-7 is-family-monospace",
              attrs: { slot: "no-results" },
              slot: "no-results",
            },
            [
              _vm.isLoading
                ? _c("span", [_vm._v("Cargando...")])
                : _c("span", [_vm._v("~ Fin del listado ~")]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }